
import { ControlFacet } from '../models/controls/ControlFacet';

/**
 * This control is an internal component used to link `ItemsScope` and `getItemsScope`.
 * Do not use or override this control in addons or host applications.
 * @internal
 */
export const itemsScopeHostControl = new ControlFacet<{}, {
  /**
   * The itemsScopeItemKey seen by components within the ItemsScope.
   * In general, do not override this as `ItemsScope` supplies it automatically.
   */
  itemsScopeItemKey: string;
}>('itemsScopeHostControl');
